import { h } from "@stencil/core";
/* eslint-disable */
export const ProgressAnimation = () => (
    <svg width='100%' height='100%' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <title>animated-loading</title>
        <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
            <path
                d='M17.9592757,9.18231582 L19.5308353,15.0520462 C17.6920831,15.9680245 16.2220369,17.4113297 15.2606438,19.1395666 L9.35402463,17.5568896 C10.9886197,13.8475596 14.0134414,10.7851342 17.9592757,9.18231582 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='1.25s' repeatCount='indefinite' />
            </path>

            <path
                d='M8.21024261,21.3905738 L14.0518311,22.9569858 C13.92737,24.141698 14.0140148,25.3688289 14.3407417,26.5881905 C14.5869753,27.5071468 14.9535059,28.361745 15.4188507,29.1395822 L11.0945433,33.4650268 C9.95251686,31.9086827 9.07488485,30.1179648 8.54518678,28.1411047 C7.93540256,25.865359 7.84828199,23.5726992 8.21024261,21.3905738 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='1s' repeatCount='indefinite' />
            </path>

            <path
                d='M24.6035668,33.9837377 L26.1774214,39.8528531 C21.6561224,40.4796525 17.2127215,39.125525 13.8477152,36.3681076 L18.1245792,32.0923408 C19.9657535,33.4274244 22.2479372,34.1286276 24.6035668,33.9837377 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='0.75s' repeatCount='indefinite' />
            </path>

            <path
                d='M33.1344341,28.0704623 L38.9761904,29.6349529 C37.4408309,33.7051508 34.2701494,37.0993605 30.0416557,38.8173058 L28.4682515,32.9484087 C30.5811762,31.8961213 32.2073386,30.147565 33.1344341,28.0704623 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='0.5s' repeatCount='indefinite' />
            </path>

            <path
                d='M39.4548132,19.8588953 C39.9845113,21.8357554 40.1198186,23.8253786 39.9089667,25.7442253 L34.0012844,24.1604342 C34.0153662,23.254135 33.9054919,22.3307659 33.6592583,21.4118095 C33.3324332,20.1920819 32.7936791,19.0857349 32.0932292,18.1217708 L36.3703147,13.8461397 C37.7745019,15.5547587 38.8451298,17.5835259 39.4548132,19.8588953 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='0.25s' repeatCount='indefinite' />
            </path>

            <path
                d='M33.4622315,11.097115 L29.1382878,15.421063 C27.4412976,14.4048944 25.4461681,13.8899762 23.3954149,14.016325 L21.8235745,8.1470089 C26.0418338,7.56249057 30.192223,8.70222701 33.4622315,11.097115 Z'
                fill='currentColor'
                opacity='0'
            >
                <animate attributeName='opacity' from='1' to='0' dur='1.5s' begin='0s' repeatCount='indefinite' />
            </path>
        </g>
    </svg>
);
